import React from 'react';
import classnames from 'classnames';
import Element from '../../../element';
import styles from '../card.module.scss';

interface IProps {
    className?: string;
}

export default function CardHeaderIcon({ className, ...props }: IProps) {
    return (
        <Element
            {...props}
            className={classnames(styles['card-header-icon'], className)}
        />
    );
}
